import type { SVGProps } from 'react';
const SvgSouthEast = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#south_east_svg__a)">
      <path
        fill="currentColor"
        d="M19 9h-2v6.59L5.41 4 4 5.41 15.59 17H9v2h10V9Z"
      />
    </g>
    <defs>
      <clipPath id="south_east_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSouthEast;
